"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParametricPlane = void 0;
const ParametricLine_1 = require("./ParametricLine");
const Vector3_1 = require("../ValueObjects/Vector3");
class ParametricPlane {
    constructor(point, normal) {
        this.point = point;
        this.normal = normal;
    }
    static FromPointNormal(point, normal) {
        return new ParametricPlane(point, normal);
    }
    static FromThreePoints(A, B, C) {
        const point = A;
        const AB = Vector3_1.Vector3.Subtract(B, A);
        const AC = Vector3_1.Vector3.Subtract(C, A);
        const normal = Vector3_1.Vector3.Cross(AB, AC);
        return new ParametricPlane(point, normal);
    }
    static XY() {
        const p = Vector3_1.Vector3.Zero();
        const n = new Vector3_1.Vector3(0, 0, 1);
        return new ParametricPlane(p, n);
    }
    static ZX() {
        const p = Vector3_1.Vector3.Zero();
        const n = new Vector3_1.Vector3(0, 1, 0);
        return new ParametricPlane(p, n);
    }
    static YZ() {
        const p = Vector3_1.Vector3.Zero();
        const n = new Vector3_1.Vector3(1, 0, 0);
        return new ParametricPlane(p, n);
    }
    GetParameters() {
        const a = this.normal.x;
        const b = this.normal.y;
        const c = this.normal.z;
        let d = Vector3_1.Vector3.Dot(this.point, this.normal);
        if (d !== 0) {
            d *= -1;
        }
        return {
            a,
            b,
            c,
            d,
        };
    }
    intersectLine(line) {
        const { x0, y0, z0, a, b, c } = line;
        const { a: A, b: B, c: C, d: D } = this.GetParameters();
        const tNumerator = -(A * x0 + B * y0 + C * z0 + D);
        const tDenominator = A * a + B * b + C * c;
        if (tDenominator === 0) {
            return undefined;
        }
        const t = tNumerator / tDenominator;
        const intersect = ParametricLine_1.ParametricLine.GetPointAtDistance(line, t);
        return intersect;
    }
}
exports.ParametricPlane = ParametricPlane;
